import type React from 'react'
import type { JSX } from 'react'
import type {
  DropdownItemFontColors,
  DropdownItemPadding,
} from '../DropdownItem.h'

import {
  DropdownItemBackgrounds,
  DropdownItemColumnGap,
  DropdownItemPaddings,
} from '../DropdownItem.h'
import { DropdownItemNoClickableSC } from './DropdownItemNoClickable.styled'

export interface IDropdownItemNoClickableProps {
  disabled?: boolean
  width?: string
  height?: number
  paddings?: DropdownItemPadding
  columnGap?: DropdownItemColumnGap
  colorDefault?: DropdownItemFontColors
  backgroundDefault?: DropdownItemBackgrounds
  children?: React.ReactNode
}

export const DropdownItemNoClickable = ({
  disabled = false,
  width = '100%',
  height = 0,
  paddings = DropdownItemPaddings.SIZE_0,
  columnGap = DropdownItemColumnGap.INDENT_0,
  backgroundDefault = DropdownItemBackgrounds.TRANSPARENT,
  children,
}: IDropdownItemNoClickableProps): JSX.Element => {
  return (
    <DropdownItemNoClickableSC
      disabled={disabled}
      width={width}
      height={height}
      paddings={paddings}
      columnGap={columnGap}
      backgroundDefault={backgroundDefault}
    >
      {children}
    </DropdownItemNoClickableSC>
  )
}
